import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import MultiSelectComponent from "../../components/MultiSelect";
import ReportingDropdown from "./ReportingDropdown";
import {
    changesReportType,
    CONVERGE_TYPE,
    CUSTOM_DATE_RANGE,
    disabilityType,
    INCLUDE_HISTORICAL_LEAVE,
    leaveType,
    lifeType,
    absenceType,
    PAYMENT_STATUS,
    paymentHistoryType,
    PERIOD_SCHEDULE_TYPE,
    PLAN_REQUEST_STATUS,
    PROTECTION_STATUS,
    REPORTING_GROUP,
    REPORTING_PERIOD,
    STATUS,
    APPLY_REPORTING_PERIOD_TO,
    All_Open_Absences,
    Disability_Summary,
    REPORTING_PERIOD_MESSGAE,
    LEAVE_SCHEDULE_TYPE,
    ACTIVE_ABSENCE_TYPES_MESSAGE,
    LEAVE_SUMMARY_SUBVIEW,
    LEAVE_PERIOD_PROTECTION_DETAIL_SUBVIEW,
    LEAVE_DETAILS_SUBVIEW,
    ANALYSIS_TYPE,
} from "../../constants";
import Calendar from "../../components/Calendar";
import Button from "../../components/ui/Button";
import Tooltip from "../../components/ui/Tooltip";
import {
    getReportingPeriodDateBounds,
    capReportingPeriodEndToToday,
} from "../../utils/helpers";
import PoliciesAndDivisions from "./PoliciesAndDivisions";
import GTM from "../../GTM";
import PropTypes from "prop-types";

const ReportFilters = ({
    isHighVolumeReportResult,
    organizationName,
    userSelectedOrganizationReports,
    reportId,
    dataViewType,
    isFetchingReportData,
    isPaginating,
    relatedOrganizationNames,
    reportParametersOptions,
    reportViewType,
    enableCoverageType,
    enableStatusFilter,
    enablePaymentStatus,
    enablePeriodScheduleTypeFilter,
    enablePeriodStatusFilter,
    enableProtectionStatusFilter,
    enableIncludeHistoricalLeave,
    enableReportingPeriodFilter,
    enableReportGroupFilter,
    enablePolicyandDivisisonFilter,
    reportingGroup,
    selectedCoverageType,
    setSelectedCoverageType,
    selectedStatus,
    selectedPaymentStatus,
    setSelectedStatus,
    setSelectedPaymentStatus,
    selectedPeriodScheduleType,
    setSelectedPeriodScheduleType,
    selectedPeriodStatus,
    setSelectedPeriodStatus,
    selectedProtectionStatus,
    setSelectedProtectionStatus,
    selectedIncludeHistoricalLeave,
    setSelectedIncludeHistoricalLeave,
    selectedReportingPeriod,
    setSelectedReportingPeriod,
    setSelectedPolicyDivision,
    initialReportingPeriod,
    setOnApplyFilter,
    setEnableSaveButton,
    resetFilters,
    setResetFilters,
    hiddenFilterValues,
    selectedPolicyDivision,
    selectedReportingGroup,
    setSelectedReportingGroup,
    allowedPoliciesAndDivisions,
    initialReportingGroup,
    initialPolicyDivision,
    setTotalResults,
    setRetrievedCount,
    initialCoverageFilter,
    initialStatusFilter,
    initialPaymentStatus,
    initialPeriodScheduleTypes,
    initialPeriodStatuses,
    initialProtectionStatuses,
    initialIncludeHistoricalLeave,
    dropdownSelectedReport,
    subviewName,
    enableApplyReportingPeriodFilter,
    setApplyingReportingPeriod,
    selectedApplyingReportingPeriod,
    initialApplyingReportingPeriodFilter,
    handleDropdownSelectedReport,
    reportDropdownOptions,
    viewtype,
    setHighVolumeCardMessage,
    highVolumeMessages,
    applyFilter,
    setApplyFilter,
    filtersVisible,
    setFiltersVisible,
}) => {
    const gtm = new GTM(null);
    const popupRef = useRef(null);
    const daterangeref = useRef(null);
    const [enableresetFilter, setEnableResetFilters] = useState(false);

    const [tempSelectedCoverageType, setTempSelectedCoverageType] =
        useState(selectedCoverageType);
    const [tempSelectedStatus, setTempSelectedStatus] =
        useState(selectedStatus);
    const [tempSelectedPeriodScheduleType, setTempSelectedPeriodScheduleType] =
        useState(selectedPeriodScheduleType);
    const [tempSelectedPeriodStatus, setTempSelectedPeriodStatus] =
        useState(selectedPeriodStatus);
    const [tempSelectedProtectionStatus, setTempSelectedProtectionStatus] =
        useState(selectedProtectionStatus);
    const [
        tempSelectedIncludeHistoricalLeave,
        setTempSelectedIncludeHistoricalLeave,
    ] = useState(selectedIncludeHistoricalLeave);
    const [tempSelectedReportingPeriod, setTempSelectedReportingPeriod] =
        useState(selectedReportingPeriod);
    const [tempSelectedReportingGroup, setTempSelectedReportingGroup] =
        useState(selectedReportingGroup);
    const [tempSelectedPolicyDivision, setTempSelectedPolicyDivision] =
        useState(selectedPolicyDivision);
    const [tempSelectedPaymentStatus, setTempSelectedPaymentStatus] = useState(
        selectedPaymentStatus
    );
    const [tempApplyingReportingPeriod, setTempApplyingReportingPeriod] =
        useState(selectedApplyingReportingPeriod);

    const shouldShowReportSelector = isHighVolumeReportResult !== false;

    const coverage_type = tempSelectedCoverageType
        .map((item) => item.value)
        .join(", ");
    const include_historical_leave = tempSelectedIncludeHistoricalLeave
        .map((item) => item.value)
        .join(", ");
    const period_schedule_type = tempSelectedPeriodScheduleType
        .map((item) => item.value)
        .join(", ");
    const reporting_group = tempSelectedReportingGroup
        .map((item) => item.value)
        .join(", ");
    const payment_status = tempSelectedPaymentStatus
        .map((item) => item.value)
        .join(", ");

    const handleApplyFilters = () => {
        // Update applied filters
        setSelectedCoverageType(tempSelectedCoverageType);
        setSelectedStatus(tempSelectedStatus);
        setSelectedPaymentStatus(tempSelectedPaymentStatus);
        setSelectedPeriodScheduleType(tempSelectedPeriodScheduleType);
        setSelectedPeriodStatus(tempSelectedPeriodStatus);
        setSelectedProtectionStatus(tempSelectedProtectionStatus);
        setSelectedIncludeHistoricalLeave(tempSelectedIncludeHistoricalLeave);
        setSelectedReportingPeriod(tempSelectedReportingPeriod);
        setSelectedReportingGroup(tempSelectedReportingGroup);
        setSelectedPolicyDivision(tempSelectedPolicyDivision);
        setApplyingReportingPeriod(tempApplyingReportingPeriod);
        setOnApplyFilter(true);
        setEnableSaveButton(enableresetFilter);
        setApplyFilter(false);
        setTotalResults(0);
        setRetrievedCount(0);
        gtm.Event(
            "custom_event",
            "button",
            "click",
            "apply filters",
            "report detail",
            reportViewType?.toLowerCase(),
            "apply_filters",
            "undefined",
            tempSelectedReportingPeriod?.displayName,
            coverage_type,
            payment_status,
            tempSelectedPolicyDivision,
            reporting_group,
            include_historical_leave,
            period_schedule_type
        );
    };

    const handleResetFilters = () => {
        setTempSelectedCoverageType(initialCoverageFilter);
        setTempSelectedStatus(initialStatusFilter);
        setTempSelectedPaymentStatus(initialPaymentStatus);
        setTempSelectedPeriodScheduleType(initialPeriodScheduleTypes);
        setTempSelectedPeriodStatus(initialPeriodStatuses);
        setTempSelectedProtectionStatus(initialProtectionStatuses);
        setTempSelectedIncludeHistoricalLeave(initialIncludeHistoricalLeave);
        setTempSelectedReportingPeriod(initialReportingPeriod);
        setTempSelectedPolicyDivision(initialPolicyDivision);
        setTempApplyingReportingPeriod(initialApplyingReportingPeriodFilter);
        setReportingPeriodOptions(reportingPeriodOptions);
        if (
            dropdownSelectedReport.ownerType === "Personal" ||
            dropdownSelectedReport.ownerType === "Shared"
        ) {
            setTempSelectedReportingGroup(initialReportingGroup);
        } else {
            setTempSelectedReportingGroup(reportingGroup);
        }
        setApplyFilter(true);
        setEnableResetFilters(false);
        handleGtmTags("reset filters");
    };

    // Track report changes to reset filters
    const lastReportKeyRef = useRef(dropdownSelectedReport?.key);

    useEffect(() => {
        const currentReportKey = dropdownSelectedReport?.key;
        const reportChanged = lastReportKeyRef.current !== currentReportKey;

        if (resetFilters || reportChanged) {
            // Reset all temp filters to their initial values
            setTempSelectedCoverageType(initialCoverageFilter);
            setTempSelectedStatus(initialStatusFilter);
            setTempSelectedPaymentStatus(initialPaymentStatus);
            setTempSelectedPeriodScheduleType(initialPeriodScheduleTypes);
            setTempSelectedPeriodStatus(initialPeriodStatuses);
            setTempSelectedProtectionStatus(initialProtectionStatuses);
            setTempSelectedIncludeHistoricalLeave(
                initialIncludeHistoricalLeave
            );
            setTempSelectedReportingPeriod(initialReportingPeriod);
            setTempSelectedPolicyDivision(initialPolicyDivision);
            setReportingPeriodOptions(reportingPeriodOptions);
            // Use appropriate default for reporting group based on owner type
            if (
                dropdownSelectedReport?.ownerType === "Personal" ||
                dropdownSelectedReport?.ownerType === "Shared"
            ) {
                setTempSelectedReportingGroup(initialReportingGroup);
            } else {
                setTempSelectedReportingGroup(reportingGroup);
            }

            setTempApplyingReportingPeriod(
                initialApplyingReportingPeriodFilter
            );
            setReportingPeriodOptions(reportingPeriodOptions);
            setEnableResetFilters(false);

            if (resetFilters) {
                setResetFilters(false);
            }

            // Update the ref to track the new report
            if (reportChanged) {
                lastReportKeyRef.current = currentReportKey;
            }
        }
    }, [
        resetFilters,
        dropdownSelectedReport?.key,
        dropdownSelectedReport?.ownerType,
        initialCoverageFilter,
        initialStatusFilter,
        initialPaymentStatus,
        initialPeriodScheduleTypes,
        initialPeriodStatuses,
        initialProtectionStatuses,
        initialIncludeHistoricalLeave,
        initialReportingPeriod,
        initialPolicyDivision,
        initialReportingGroup,
        reportingGroup,
        initialApplyingReportingPeriodFilter,
    ]);

    const [isOpenReportingPeriod, setOpenReportingPeriod] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);

    const [minimumStartDate, setMinimumStartDate] = useState(null);
    const [maximumStartDate, setMaximumStartDate] = useState(null);
    const [maximumEndDate, setMaximumEndDate] = useState(null);

    const dropdownWrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownWrapperRef.current &&
                !dropdownWrapperRef.current.contains(event.target)
            ) {
                setOpenReportingPeriod(false);
                setShowCalendar(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setShowCalendar]);

    // Simple toggle: open if closed, close if open
    const toggleDropdown = () => {
        setOpenReportingPeriod((prev) => {
            // If we're opening the dropdown, but calendar is open, close the calendar
            if (!prev && showCalendar) {
                setShowCalendar(false);
            }
            return !prev;
        });
    };

    const closeDropdown = () => setOpenReportingPeriod(false);
    const handleGtmTags = (label) => {
        gtm.Event(
            "custom_event",
            "filter",
            "select",
            label,
            "report detail",
            dataViewType?.toLowerCase(),
            "field_interaction",
            "",
            "reset filters"
        );
    };

    const [searchTerm, setSearchTerm] = useState("");
    const {
        coverageTypeOptions,
        coverageTypeHeader,
        statusOptions,
        paymentStatusOptions,
        periodScheduleTypeOptions,
        periodStatusOptions,
        protectionStatusOptions,
        includeHistoricalLeaveOptions,
        reportingPeriodOptions,
        applyReportingPeriodToOptions,
    } = useMemo(() => {
        const getOptions = (name) =>
            reportParametersOptions.find(
                (param) => param.parameterName === name
            )?.options || [];

        return {
            coverageTypeOptions: getOptions(CONVERGE_TYPE),
            coverageTypeHeader: reportParametersOptions.find(
                (param) => param.parameterName === CONVERGE_TYPE
            )?.parameterName,
            statusOptions: getOptions(STATUS).map(({ name }) => ({
                name,
                value: name,
            })),
            paymentStatusOptions: getOptions(PAYMENT_STATUS).map(
                ({ name }) => ({
                    name,
                    value: name,
                })
            ),
            periodScheduleTypeOptions: getOptions(PERIOD_SCHEDULE_TYPE),
            periodStatusOptions: getOptions(PLAN_REQUEST_STATUS),
            protectionStatusOptions: getOptions(PROTECTION_STATUS).map(
                (option) => {
                    if (Array.isArray(option.value)) {
                        const matchedValue = option.value.find(
                            (val) => val === option.name
                        );
                        return {
                            name: option.name,
                            value: matchedValue ?? option.value[0],
                        };
                    }
                    return option;
                }
            ),
            includeHistoricalLeaveOptions: getOptions(INCLUDE_HISTORICAL_LEAVE),
            reportingPeriodOptions: getOptions(REPORTING_PERIOD),
            applyReportingPeriodToOptions: getOptions(
                APPLY_REPORTING_PERIOD_TO
            ).map(({ name, value }) => ({
                name,
                value: value,
            })),
        };
    }, [reportParametersOptions]);

    const [reportingPeriodOptionss, setReportingPeriodOptions] = useState(
        reportingPeriodOptions
    );

    useEffect(() => {
        if (reportingPeriodOptions) {
            setReportingPeriodOptions(reportingPeriodOptions);
        }
    }, [reportingPeriodOptions]);

    const originalCustomRangeBounds = useMemo(() => {
        const customRange = reportingPeriodOptions?.find(
            (option) => option.name === CUSTOM_DATE_RANGE
        );
        return {
            minimumStartDate: customRange?.value?.minimumStartDate,
            maximumEndDate: customRange?.value?.maximumEndDate,
        };
    }, [reportingPeriodOptions]);

    const resolveCustomRangeBounds = useCallback(
        () =>
            getReportingPeriodDateBounds({
                subviewName,
                applyingReportingPeriod: tempApplyingReportingPeriod,
                minimumStartDate: originalCustomRangeBounds.minimumStartDate,
                maximumEndDate: originalCustomRangeBounds.maximumEndDate,
            }),
        [subviewName, tempApplyingReportingPeriod, originalCustomRangeBounds]
    );

    const handleReportingPeriod = (name) => {
        gtm.Event(
            "custom_event",
            "filter",
            "select",
            "reporting period",
            "report detail",
            reportViewType?.toLowerCase(),
            "filter_date",
            name.name.toLowerCase()
        );
        setApplyFilter(true);
        setEnableResetFilters(true);
        closeDropdown();
        if (name.name === CUSTOM_DATE_RANGE) {
            setShowCalendar(true);
            const {
                minimumStartDate: resolvedMinDate,
                maximumStartDate: resolvedMaxStartDate,
                maximumEndDate: resolvedMaxDate,
            } = resolveCustomRangeBounds();
            setMinimumStartDate(resolvedMinDate);
            setMaximumStartDate(resolvedMaxStartDate ?? null);
            setMaximumEndDate(resolvedMaxDate);
        } else {
            setTempSelectedReportingPeriod(name);
            setReportingPeriodOptions(reportingPeriodOptions);
        }
    };

    useEffect(() => {
        if (!showCalendar) {
            return;
        }

        const {
            minimumStartDate: resolvedMinDate,
            maximumStartDate: resolvedMaxStartDate,
            maximumEndDate: resolvedMaxDate,
        } = resolveCustomRangeBounds();

        if (resolvedMinDate !== minimumStartDate) {
            setMinimumStartDate(resolvedMinDate);
        }
        if ((resolvedMaxStartDate ?? null) !== maximumStartDate) {
            setMaximumStartDate(resolvedMaxStartDate ?? null);
        }
        if (resolvedMaxDate !== maximumEndDate) {
            setMaximumEndDate(resolvedMaxDate);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showCalendar, resolveCustomRangeBounds]);

    const previousApplyingReportingPeriodRef = useRef(
        tempApplyingReportingPeriod
    );
    useEffect(() => {
        if (
            previousApplyingReportingPeriodRef.current ===
            tempApplyingReportingPeriod
        ) {
            return;
        }
        previousApplyingReportingPeriodRef.current =
            tempApplyingReportingPeriod;

        // Apply-to changed: cap a future "To" date at today, keeping "From".
        const cappedPeriod = capReportingPeriodEndToToday(
            tempSelectedReportingPeriod
        );
        if (cappedPeriod !== tempSelectedReportingPeriod) {
            setTempSelectedReportingPeriod(cappedPeriod);
            setReportingPeriodOptions((prev) =>
                prev.map((option) =>
                    option.name === CUSTOM_DATE_RANGE ? cappedPeriod : option
                )
            );
        }
    }, [tempApplyingReportingPeriod]);

    const leaveTypeMessageMap = {
        "Intermittent Leave": REPORTING_PERIOD_MESSGAE?.intermittentLeaveType,
        "Continuous Leave": REPORTING_PERIOD_MESSGAE?.continuousLeaveType,
        "Reduced Schedule Leave":
            REPORTING_PERIOD_MESSGAE?.reducedScheduleLeaveType,
        [LEAVE_DETAILS_SUBVIEW]: REPORTING_PERIOD_MESSGAE?.leaveTypeApply,
        [LEAVE_PERIOD_PROTECTION_DETAIL_SUBVIEW]:
            REPORTING_PERIOD_MESSGAE?.leaveTypeApply,
        [LEAVE_SUMMARY_SUBVIEW]: REPORTING_PERIOD_MESSGAE?.leaveTypeApply,
        "Leave As Accommodation Report (TL)":
            REPORTING_PERIOD_MESSGAE?.leaveTypeApply,
    };

    const leaveTypes =
        leaveTypeMessageMap[subviewName] ?? REPORTING_PERIOD_MESSGAE?.leaveType;

    const lifeReportType =
        dropdownSelectedReport?.label === "Life - Paid Claims"
            ? REPORTING_PERIOD_MESSGAE?.lifePaidClaims
            : REPORTING_PERIOD_MESSGAE?.lifeType;

    const absencetypeapply =
        dropdownSelectedReport?.label === All_Open_Absences
            ? REPORTING_PERIOD_MESSGAE?.defaultMessage
            : REPORTING_PERIOD_MESSGAE?.absenceApply;

    const disabilitysummary =
        dropdownSelectedReport?.label === Disability_Summary
            ? REPORTING_PERIOD_MESSGAE?.disabilityType
            : REPORTING_PERIOD_MESSGAE?.disabilitytypeApply;

    const reportingPeriodMessage = useMemo(() => {
        switch (dataViewType) {
            case disabilityType:
                return disabilitysummary;
            case leaveType:
                return leaveTypes;
            case paymentHistoryType:
                return REPORTING_PERIOD_MESSGAE?.paymentHistoryType;
            case changesReportType:
                return REPORTING_PERIOD_MESSGAE?.changesReportType;
            case lifeType:
                return lifeReportType;
            case absenceType:
                return absencetypeapply;

            default:
                return REPORTING_PERIOD_MESSGAE?.defaultMessage;
        }
    }, [
        dataViewType,
        leaveTypes,
        lifeReportType,
        disabilitysummary,
        absencetypeapply,
    ]);

    const activeAbsenceMessage = useMemo(() => {
        switch (dataViewType) {
            case disabilityType:
                return ACTIVE_ABSENCE_TYPES_MESSAGE?.disabilitytype;
            case leaveType:
                return ACTIVE_ABSENCE_TYPES_MESSAGE?.leaveType;
            case absenceType:
                return ACTIVE_ABSENCE_TYPES_MESSAGE?.absenceType;
        }
    }, [dataViewType]);

    const multiSelectFilters = [
        {
            enabled: enableApplyReportingPeriodFilter,
            header: APPLY_REPORTING_PERIOD_TO,
            options: applyReportingPeriodToOptions,
            selected: tempApplyingReportingPeriod, // Use temp state
            setSelected: setTempApplyingReportingPeriod,
            label: APPLY_REPORTING_PERIOD_TO,
            showCheckboxes: false,
            enableSearch: false,
        },
        {
            enabled: enableCoverageType,
            header: coverageTypeHeader,
            options: coverageTypeOptions,
            selected: tempSelectedCoverageType, // Use temp state
            setSelected: setTempSelectedCoverageType,
            label: CONVERGE_TYPE,
            enableSearch: false,
        },
        {
            enabled: enableStatusFilter,
            header: STATUS,
            options: statusOptions,
            selected: tempSelectedStatus, // Use temp state
            setSelected: setTempSelectedStatus,
            label: STATUS,
            enableSearch: false,
        },
        {
            enabled: enablePaymentStatus,
            header: PAYMENT_STATUS,
            options: paymentStatusOptions,
            selected: tempSelectedPaymentStatus, // Use temp state
            setSelected: setTempSelectedPaymentStatus,
            label: PAYMENT_STATUS,
            enableSearch: false,
        },
        {
            enabled: enablePeriodScheduleTypeFilter,
            header: LEAVE_SCHEDULE_TYPE,
            options: periodScheduleTypeOptions,
            selected: tempSelectedPeriodScheduleType, // Use temp state
            setSelected: setTempSelectedPeriodScheduleType,
            label: LEAVE_SCHEDULE_TYPE,
            enableSearch: false,
        },
        {
            enabled: enablePeriodStatusFilter,
            header: PLAN_REQUEST_STATUS,
            options: periodStatusOptions,
            selected: tempSelectedPeriodStatus, // Use temp state
            setSelected: setTempSelectedPeriodStatus,
            label: PLAN_REQUEST_STATUS,
            enableSearch: false,
        },
        {
            enabled: enableProtectionStatusFilter,
            header: PROTECTION_STATUS,
            options: protectionStatusOptions,
            selected: tempSelectedProtectionStatus, // Use temp state
            setSelected: setTempSelectedProtectionStatus,
            label: PROTECTION_STATUS,
            enableSearch: false,
        },
        {
            enabled: enableIncludeHistoricalLeave,
            header: INCLUDE_HISTORICAL_LEAVE,
            options: includeHistoricalLeaveOptions,
            selected: tempSelectedIncludeHistoricalLeave, // Use temp state
            setSelected: setTempSelectedIncludeHistoricalLeave,
            label: INCLUDE_HISTORICAL_LEAVE,
            showCheckboxes: false,
            enableSearch: false,
        },
        {
            enabled: enableReportGroupFilter,
            header: REPORTING_GROUP,
            options: reportingGroup,
            selected: tempSelectedReportingGroup, // Use temp state
            setSelected: setTempSelectedReportingGroup,
            label: REPORTING_GROUP,
            enableSearch: true,
            showCheckboxes: true,
        },
    ];

    const validPolicyDivisionCount = useMemo(() => {
        if (!enablePolicyandDivisisonFilter) return 1;
        const validValues = new Set(
            allowedPoliciesAndDivisions.flatMap((item) => [
                item.policyId,
                ...(item.divisions || []).map(
                    (d) => `${item.policyId}-${d.divisionId}`
                ),
            ])
        );
        return tempSelectedPolicyDivision.filter((v) => validValues.has(v))
            .length;
    }, [
        enablePolicyandDivisisonFilter,
        allowedPoliciesAndDivisions,
        tempSelectedPolicyDivision,
    ]);

    const isApplyDisabled = useMemo(() => {
        const filters = [
            [enableCoverageType, tempSelectedCoverageType.length],
            [enableStatusFilter, tempSelectedStatus.length],
            [enablePaymentStatus, tempSelectedPaymentStatus.length],
            [
                enablePeriodScheduleTypeFilter,
                tempSelectedPeriodScheduleType.length,
            ],
            [enablePeriodStatusFilter, tempSelectedPeriodStatus.length],
            [enableProtectionStatusFilter, tempSelectedProtectionStatus.length],
            [enableReportGroupFilter, tempSelectedReportingGroup.length],
            [enablePolicyandDivisisonFilter, validPolicyDivisionCount],
            [
                enableApplyReportingPeriodFilter,
                tempApplyingReportingPeriod?.length,
            ],
        ];

        return (
            filters.some(
                ([enabled, valueLength]) => enabled && valueLength === 0
            ) ||
            (enableReportingPeriodFilter && !tempSelectedReportingPeriod?.name)
        );
    }, [
        enableCoverageType,
        tempSelectedCoverageType.length,
        enableStatusFilter,
        tempSelectedStatus.length,
        enablePaymentStatus,
        tempSelectedPaymentStatus.length,
        enablePeriodScheduleTypeFilter,
        tempSelectedPeriodScheduleType.length,
        enablePeriodStatusFilter,
        tempSelectedPeriodStatus.length,
        enableProtectionStatusFilter,
        tempSelectedProtectionStatus.length,
        enableReportGroupFilter,
        tempSelectedReportingGroup.length,
        enablePolicyandDivisisonFilter,
        validPolicyDivisionCount,
        enableApplyReportingPeriodFilter,
        tempApplyingReportingPeriod?.length,
        enableReportingPeriodFilter,
        tempSelectedReportingPeriod,
    ]);

    const handleConfirmButton = (item) => {
        setShowCalendar(false);

        // Set the custom range with the confirmed start and end dates
        const updatedCustomRange = {
            name: CUSTOM_DATE_RANGE,
            displayName: `${CUSTOM_DATE_RANGE} ${item.startDate} - ${item.endDate}`,
            value: {
                effectiveStartDt: item.startDate,
                effectiveEndDt: item.endDate,
                minimumStartDate: minimumStartDate,
                maximumEndDate: maximumEndDate,
            },
        };
        // Update the "Reporting Period" options with the new custom range
        const updatedOptions = reportingPeriodOptions.map((option) => {
            if (option.name === CUSTOM_DATE_RANGE) {
                setApplyFilter(true);
                setEnableResetFilters(true);
                return updatedCustomRange;
            }
            return option;
        });
        // Update the state with the new options
        setReportingPeriodOptions(updatedOptions);
        // Optionally update the selected reporting period
        setTempSelectedReportingPeriod(updatedCustomRange);
    };

    const priorityOrder = ["Coverage type"];

    const formattedHiddenFilters = hiddenFilterValues
        ?.map((obj) => ({
            label: obj.parameterName,
            value: obj.name?.length ? obj.name.join(", ") : "None",
        }))
        .sort((a, b) => {
            const aIndex = priorityOrder.indexOf(a.label);
            const bIndex = priorityOrder.indexOf(b.label);

            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;

            return aIndex - bIndex;
        });

    const handlePolicyCheckboxChange = (policyId) => {
        setEnableResetFilters(true);
        const policyDivisions =
            filteredPoliciesAndDivisions.find(
                (item) => item.policyId === policyId
            )?.divisions || [];
        const divisionIds = policyDivisions.map(
            (division) => `${policyId}-${division.divisionId}`
        );

        setTempSelectedPolicyDivision((prevSelected) => {
            if (prevSelected.includes(policyId)) {
                return prevSelected.filter(
                    (item) => item !== policyId && !divisionIds.includes(item)
                );
            } else {
                // Remove duplicates by using a Set
                return [
                    ...new Set([...prevSelected, policyId, ...divisionIds]),
                ];
            }
        });
        setApplyFilter(true);
        setEnableResetFilters(true);
    };

    const filteredPoliciesAndDivisions =
        searchTerm.length < 3
            ? allowedPoliciesAndDivisions
            : allowedPoliciesAndDivisions.filter((item) => {
                  return (
                      item.policyId
                          ?.toLowerCase()
                          .includes(searchTerm.toLowerCase()) ||
                      item.divisions.some(
                          (division) =>
                              division.divisionName
                                  ?.toLowerCase()
                                  .includes(searchTerm.toLowerCase()) ||
                              division.divisionId
                                  ?.toLowerCase()
                                  .includes(searchTerm.toLowerCase())
                      )
                  );
              });

    const handleDivisionCheckboxChange = (divisionId, policyId) => {
        setTempSelectedPolicyDivision((prevSelected) => {
            const policyDivisions =
                filteredPoliciesAndDivisions
                    .find((item) => item.policyId === policyId)
                    ?.divisions.map(
                        (division) => `${policyId}-${division.divisionId}`
                    ) || [];

            const newSelected = prevSelected.includes(divisionId)
                ? prevSelected.filter((item) => item !== divisionId)
                : [...prevSelected, divisionId];

            const allPolicyDivisionsSelected = policyDivisions.every((id) =>
                newSelected.includes(id)
            );

            if (allPolicyDivisionsSelected) {
                return [...new Set([...newSelected, policyId])];
            } else {
                return newSelected.filter((item) => item !== policyId);
            }
        });
        setApplyFilter(true);
        setEnableResetFilters(true);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSelectAll = () => {
        const allItems = filteredPoliciesAndDivisions.flatMap((item) => [
            item.policyId,
            ...item.divisions.map(
                (division) => `${item.policyId}-${division.divisionId}`
            ),
        ]);
        setTempSelectedPolicyDivision(allItems);
        setEnableResetFilters(true);
        setApplyFilter(true);
    };

    const handleUnselectAll = () => {
        setTempSelectedPolicyDivision([]);
        setApplyFilter(false);
        setEnableResetFilters(true);
    };

    const clearSearch = () => {
        setSearchTerm("");
    };

    const isFilterToggleDisabled =
        dropdownSelectedReport === null || dropdownSelectedReport === undefined;

    return (
        <div
            className="section-card container-heading data-view-card"
            style={
                isFetchingReportData || isPaginating
                    ? { pointerEvents: "none", opacity: "0.4" }
                    : {}
            }
        >
            <div
                className="row d-flex"
                style={{ position: "relative", rowGap: 16 }}
            >
                {shouldShowReportSelector && (
                    <div className="organization-info col-lg-3 col-md-6 col-sm-4 col-6 col-print">
                        <label
                            className="pb-0 header"
                            htmlFor="organization-name"
                        >
                            {viewtype} Report
                        </label>
                        <ReportingDropdown
                            handleDropdownSelectedReport={
                                handleDropdownSelectedReport
                            }
                            dropdownSelectedReport={dropdownSelectedReport}
                            reportDropdownOptions={reportDropdownOptions}
                            setApplyFilter={setApplyFilter}
                            activeAbsenceMessage={activeAbsenceMessage}
                        />
                    </div>
                )}
                <div className="organization-info col-lg-3 col-md-6 col-sm-4 col-6 col-print">
                    <label className="pb-0 header" htmlFor="organization-name">
                        Organization
                    </label>
                    <p className="sub-text" id="organization-name">
                        {organizationName.length < 30 ? (
                            organizationName
                        ) : (
                            <div className="parameter-text d-block">
                                {organizationName}
                            </div>
                        )}
                    </p>
                </div>

                {/* Related Organizations Info */}
                <div className="related-orgs-info col-lg-3 col-md-6 col-sm-4 col-6 col-print">
                    <label className="pb-0 header" htmlFor="related-orgs">
                        Related orgs
                    </label>
                    <p className="sub-text" id="related-orgs">
                        {userSelectedOrganizationReports?.[reportId]?.related
                            ?.length ? (
                            <div className="parameter-text d-block">
                                {relatedOrganizationNames}
                            </div>
                        ) : (
                            <span className="d-block">None</span>
                        )}
                    </p>
                </div>
                <div
                    className="col-auto ms-auto"
                    style={{ gridColumn: "4 / 5", justifySelf: "end" }}
                >
                    <button
                        type="button"
                        className="d-flex align-items-center filter-toggle-button"
                        disabled={isFilterToggleDisabled}
                        onKeyDown={(e) => {
                            if (isFilterToggleDisabled) {
                                return;
                            }
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setFiltersVisible((prev) => !prev);
                            }
                        }}
                        onClick={() => {
                            if (isFilterToggleDisabled) {
                                return;
                            }
                            setFiltersVisible((prev) => !prev);
                        }}
                        aria-expanded={filtersVisible}
                        aria-controls="filter-section"
                        style={
                            isFilterToggleDisabled
                                ? {
                                      opacity: 0.5,
                                      cursor: "not-allowed",
                                      border: "none",
                                      background: "transparent",
                                  }
                                : {
                                      border: "none",
                                      background: "transparent",
                                  }
                        }
                    >
                        <span style={{ paddingRight: 8 }}>
                            {filtersVisible ? "Hide filters" : "Show filters"}
                        </span>
                        <i className="fas fa-filter me-2"></i>
                    </button>
                </div>
            </div>
            {filtersVisible && (
                <>
                    <div className="row" style={{ rowGap: 16, marginTop: 10 }}>
                        {enableReportingPeriodFilter && (
                            <div className="col-lg-3 col-md-6 col-sm-4 col-6 col-print">
                                <label
                                    className="header pb-0"
                                    htmlFor="reporting-period"
                                >
                                    Reporting period
                                </label>
                                <Tooltip
                                    content={reportingPeriodMessage}
                                    tooltipId="reporting-period-tooltip"
                                    tooltipClassName="reporting-period-tooltip"
                                    arrowClassName="tooltipArrow"
                                    icon
                                    iconAriaLabel="More information about reporting period"
                                    iconColor="#FFFFFF"
                                />
                                <div
                                    className="reporting-period"
                                    ref={dropdownWrapperRef}
                                >
                                    <div
                                        onClick={toggleDropdown}
                                        aria-expanded={isOpenReportingPeriod}
                                        role="combobox"
                                        aria-haspopup="listbox"
                                        aria-controls="reportingPeriodList"
                                        aria-label="Reporting Period"
                                        tabIndex={0}
                                    >
                                        <div className="reportTableFilter">
                                            <span>
                                                {tempSelectedReportingPeriod?.displayName ||
                                                    "Select Reporting Period"}
                                            </span>
                                            <i
                                                className={`fa-solid fa-angle-${isOpenReportingPeriod ? "up" : "down"}`}
                                                aria-hidden="true"
                                            ></i>
                                        </div>

                                        {isOpenReportingPeriod && (
                                            <ul
                                                className="reportingPeriod-dropdown"
                                                role="listbox"
                                                id="reportingPeriodList"
                                            >
                                                {reportingPeriodOptionss.map(
                                                    (option) => (
                                                        <li
                                                            key={option.name}
                                                            className={`dropdown-option ${
                                                                option?.name ===
                                                                tempSelectedReportingPeriod?.name
                                                                    ? "option-selected"
                                                                    : ""
                                                            }`}
                                                            role="option"
                                                            tabIndex={0}
                                                            onClick={() => {
                                                                handleReportingPeriod(
                                                                    option
                                                                );
                                                                setTimeout(
                                                                    () => {
                                                                        setOpenReportingPeriod(
                                                                            false
                                                                        );
                                                                    },
                                                                    0
                                                                );
                                                            }}
                                                        >
                                                            {option.displayName ||
                                                                option.name}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        )}
                                    </div>

                                    {showCalendar && (
                                        <div
                                            ref={daterangeref}
                                            tabIndex={0}
                                            onKeyDown={(e) => {
                                                if (e.key === "Escape") {
                                                    setShowCalendar(false);
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                }
                                            }}
                                        >
                                            <div ref={popupRef}>
                                                <Calendar
                                                    reportViewType={
                                                        dataViewType
                                                    }
                                                    subviewName={subviewName}
                                                    setShowReportingCalendar={
                                                        setShowCalendar
                                                    }
                                                    minimumStartDate={
                                                        minimumStartDate +
                                                        "T00:00:00"
                                                    }
                                                    maximumStartDate={
                                                        maximumStartDate
                                                            ? maximumStartDate +
                                                              "T00:00:00"
                                                            : undefined
                                                    }
                                                    maximumEndDate={
                                                        maximumEndDate +
                                                        "T00:00:00"
                                                    }
                                                    handleConfirmButton={
                                                        handleConfirmButton
                                                    }
                                                    setApplyFilter={
                                                        setApplyFilter
                                                    }
                                                    setOpenReportingPeriod={
                                                        setOpenReportingPeriod
                                                    }
                                                    startDate={
                                                        tempSelectedReportingPeriod
                                                            ?.value
                                                            ?.effectiveStartDt
                                                    }
                                                    endDate={
                                                        tempSelectedReportingPeriod
                                                            ?.value
                                                            ?.effectiveEndDt
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {/* MultiSelect Filters */}
                        {multiSelectFilters.map(
                            ({
                                enabled,
                                header,
                                options,
                                selected,
                                setSelected,
                                label,
                                showCheckboxes,
                                enableSearch,
                            }) =>
                                enabled && (
                                    <MultiSelectComponent
                                        key={label}
                                        headerLabel={header}
                                        options={options}
                                        selectedOptions={selected}
                                        setSelectedOptions={setSelected}
                                        gtmTagLabel={label}
                                        showCheckboxes={showCheckboxes}
                                        setEnableReset={setEnableResetFilters}
                                        setEnableApplyButton={setApplyFilter}
                                        enableSearch={enableSearch}
                                        handleGtmTags={handleGtmTags}
                                        attribute2={dataViewType?.toLowerCase()}
                                        setHighVolumeCardMessage={
                                            setHighVolumeCardMessage
                                        }
                                        isHighVolumeReportResult={
                                            isHighVolumeReportResult
                                        }
                                        highVolumeMessages={highVolumeMessages}
                                        activeAbsenceMessage={
                                            activeAbsenceMessage
                                        }
                                    />
                                )
                        )}
                        {enablePolicyandDivisisonFilter && (
                            <PoliciesAndDivisions
                                label="Policies and divisions"
                                filteredPoliciesAndDivisions={
                                    filteredPoliciesAndDivisions
                                }
                                selectedPolicyDivision={
                                    tempSelectedPolicyDivision
                                }
                                handleSelectAll={handleSelectAll}
                                handleUnselectAll={handleUnselectAll}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                clearSearch={clearSearch}
                                handlePolicyCheckboxChange={
                                    handlePolicyCheckboxChange
                                }
                                handleDivisionCheckboxChange={
                                    handleDivisionCheckboxChange
                                }
                                attribute2={dataViewType?.toLowerCase()}
                            />
                        )}
                    </div>
                    <div className="row align-items-end">
                        <div
                            className="col-lg-9 col-md-8 col-sm-12 d-flex flex-wrap"
                            style={{ gap: 50 }}
                        >
                            {formattedHiddenFilters?.map(
                                ({ label, value }, index) => (
                                    <div
                                        key={index}
                                        className="d-flex align-items-end coverageType-section"
                                        style={{ marginTop: 10 }}
                                    >
                                        <label className="header pb-0">
                                            {label}:
                                        </label>
                                        &nbsp;
                                        <span className="coverageType-text d-block fs-sm">
                                            {value}
                                            <div className="coverage-popup">
                                                {value}.
                                            </div>
                                        </span>
                                    </div>
                                )
                            )}{" "}
                        </div>
                        <div
                            className="col-lg-3 col-md-4 col-sm-12 d-flex justify-content-end flex-nowrap"
                            style={{ gap: 10, paddingTop: 10 }}
                        >
                            <Button
                                text="Reset"
                                disabled={!enableresetFilter}
                                outline={true}
                                aria-label="Reset"
                                onClick={() => handleResetFilters()}
                            />
                            <Button
                                text="Apply"
                                disabled={isApplyDisabled || !applyFilter}
                                variant="inverse"
                                aria-label="Apply"
                                onClick={() => handleApplyFilters()}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

ReportFilters.propTypes = {
    isHighVolumeReportResult: PropTypes.bool,
    organizationName: PropTypes.string,
    userSelectedOrganizationReports: PropTypes.object,
    reportId: PropTypes.number,
    dataViewType: PropTypes.string,
    isFetchingReportData: PropTypes.bool,
    isPaginating: PropTypes.bool,
    relatedOrganizationNames: PropTypes.string,
    reportParametersOptions: PropTypes.array,
    reportViewType: PropTypes.string,
    enableCoverageType: PropTypes.bool,
    enableStatusFilter: PropTypes.bool,
    enablePaymentStatus: PropTypes.bool,
    enablePeriodScheduleTypeFilter: PropTypes.bool,
    enablePeriodStatusFilter: PropTypes.bool,
    enableProtectionStatusFilter: PropTypes.bool,
    enableIncludeHistoricalLeave: PropTypes.bool,
    enableReportingPeriodFilter: PropTypes.bool,
    enableReportGroupFilter: PropTypes.bool,
    enablePolicyandDivisisonFilter: PropTypes.bool,
    reportingGroup: PropTypes.array,
    selectedCoverageType: PropTypes.array,
    setSelectedCoverageType: PropTypes.func,
    selectedStatus: PropTypes.array,
    selectedPaymentStatus: PropTypes.array,
    setSelectedStatus: PropTypes.func,
    setSelectedPaymentStatus: PropTypes.func,
    selectedPeriodScheduleType: PropTypes.array,
    setSelectedPeriodScheduleType: PropTypes.func,
    selectedPeriodStatus: PropTypes.array,
    setSelectedPeriodStatus: PropTypes.func,
    selectedProtectionStatus: PropTypes.array,
    setSelectedProtectionStatus: PropTypes.func,
    selectedIncludeHistoricalLeave: PropTypes.array,
    setSelectedIncludeHistoricalLeave: PropTypes.func,
    selectedReportingPeriod: PropTypes.object,
    setSelectedReportingPeriod: PropTypes.func,
    selectedPolicyDivision: PropTypes.array,
    setSelectedPolicyDivision: PropTypes.func,
    initialReportingPeriod: PropTypes.object,
    setOnApplyFilter: PropTypes.func,
    setEnableSaveButton: PropTypes.func,
    resetFilters: PropTypes.bool,
    setResetFilters: PropTypes.func,
    hiddenFilterValues: PropTypes.array,
    selectedReportingGroup: PropTypes.array,
    setSelectedReportingGroup: PropTypes.func,
    allowedPoliciesAndDivisions: PropTypes.array,
    initialReportingGroup: PropTypes.array,
    initialPolicyDivision: PropTypes.array,
    setTotalResults: PropTypes.func,
    setRetrievedCount: PropTypes.func,
    initialCoverageFilter: PropTypes.array,
    initialStatusFilter: PropTypes.array,
    initialPaymentStatus: PropTypes.array,
    initialPeriodScheduleTypes: PropTypes.array,
    initialPeriodStatuses: PropTypes.array,
    initialProtectionStatuses: PropTypes.array,
    initialIncludeHistoricalLeave: PropTypes.array,
    dropdownSelectedReport: PropTypes.object,
    setApplyingReportingPeriod: PropTypes.func,
    enableApplyReportingPeriodFilter: PropTypes.bool,
    selectedApplyingReportingPeriod: PropTypes.array,
    initialApplyingReportingPeriodFilter: PropTypes.array,
    handleDropdownSelectedReport: PropTypes.func.isRequired,
    reportDropdownOptions: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            label: PropTypes.string.isRequired,
            ownerType: PropTypes.string.isRequired,
        })
    ).isRequired,
    setApplyFilter: PropTypes.func,
    viewtype: PropTypes.string,
    applyFilter: PropTypes.bool,
    setHighVolumeCardMessage: PropTypes.func,
    highVolumeMessages: PropTypes.object,
    setFiltersVisible: PropTypes.func,
    filtersVisible: PropTypes.bool,
};

export default ReportFilters;
